import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { retailerContactRouter } from './routing/retailerContactRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { retailerContactViewAccessControl } from './access-control/retailerContactAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'retailer-contact',
  totem: {
    tool: 'retailer-contact-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    scoped: [retailerContactRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.UserMenuUserManagement,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Configure and manage technical support contact information for retailer assistance',
          labelId: 'retailerContactDomain.settings.pageTitle',
          route: 'retailer-contact',
          accessControl: retailerContactViewAccessControl,
          positionNavV2: 4,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
